import { mainPath } from "../../../constants/access";

const nameTable = "roles";
const tPath = `${mainPath}.${nameTable}`;

export default tPath;
